// @ts-ignore
import toastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
// @ts-ignore
import i18n from "@/libs/i18n";
import { useContactsStore } from "@/store/useContactsStore";
import { Contact } from "@saysimple-platform/dtos";
import { useToast } from "vue-toastification/composition";

export default function useContact() {
    const toast = useToast();

    const toggleVip = (contact: Pick<Contact, "id" | "isHighPriority">): void => {
        if (!contact) {
            return;
        }

        const { updateContact } = useContactsStore();

        updateContact({
            id: contact.id,
            isHighPriority: contact.isHighPriority ? 0 : 1,
        })
            .then(() => {
                toast({
                    component: toastificationContent,
                    props: {
                        title: i18n.t("context-menu.contact.vip"),
                        text: i18n.t("context-menu.contact.notification.vip-changed"),
                        icon: "check",
                        variant: "success",
                    },
                });
            })
            .catch(() => {
                toast({
                    component: toastificationContent,
                    props: {
                        title: i18n.t("context-menu.contact.vip"),
                        text: i18n.t("context-menu.contact.notification.vip-error"),
                        icon: "exclamation-triangle",
                        variant: "error",
                    },
                });
            });
    };

    const toggleBlock = (contact: Pick<Contact, "id" | "isBlocked">) => {
        if (!contact) {
            return;
        }

        const { updateContact } = useContactsStore();

        updateContact({
            id: contact.id,
            isBlocked: contact.isBlocked ? 0 : 1,
        })
            .then(() => {
                toast({
                    component: toastificationContent,
                    props: {
                        title: i18n.t("context-menu.contact.block"),
                        text: i18n.t("context-menu.contact.notification.block-changed"),
                        icon: "check",
                        variant: "success",
                    },
                });
            })
            .catch(() => {
                toast({
                    component: toastificationContent,
                    props: {
                        title: i18n.t("context-menu.contact.block"),
                        text: i18n.t("context-menu.contact.notification.block-error"),
                        icon: "exclamation-triangle",
                        variant: "error",
                    },
                });
            });
    };

    return {
        toggleBlock,
        toggleVip,
    };
}
